export default class News {
    constructor() {
        this.el = null;
        this.brands = '';
        this.brandsParam = '';
        this.sectors = '';
        this.sectorsParam = '';
    }
    init(el) {
        if (el === undefined || el === null) {
            return;
        }
        this.el = el;

        if (this.el.querySelector('.news__container') !== null) {
            this.brands = encodeURIComponent(
                this.el.querySelector('.news__container').dataset.activeBrands
            );
            this.sectors = encodeURIComponent(
                this.el.querySelector('.news__container').dataset.activeSectors
            );

            if (this.brands != null && this.brands !== '') {
                this.brandsParam = '&manufacturer_category_names=' + this.brands + '';
            }

            if (this.sectors != null && this.sectors !== '') {
                this.sectorsParam = '&product_category_names=' + this.sectors + '';
            }
        }

        this.fetchNews();
    }
    fetchNews() {
        fetch(
            'https://www.tecworld.com/ajax-posts/?take=3&skip=0&fill_up_empty=1' +
                this.brandsParam +
                this.sectorsParam,
            {
                method: 'GET',
                cache: 'no-cache',
                headers: { 'content-type': 'application/json' }
            }
        )
            .then((response) => {
                return response.json();
            })
            .catch(() => {
                return { count: 0 };
            })
            .then((data) => {
                if (data.count === 0) {
                    return;
                }
                Object.entries(data).forEach(([data__key, data__value]) => {
                    if (data__key === 'count') {
                        return;
                    }
                    let html = '';
                    if (data__value.excerpt_image) {
                        html +=
                            '<div class="news__content-left">' +
                            '<a class="news__link module__link" href="' +
                            data__value.permalink +
                            '" rel="nofollow" target="_blank"><img class="news__image" src="' +
                            data__value.excerpt_image +
                            '" alt="' +
                            data__value.post_title +
                            '" /></a>';
                        html += '</div>';
                    }
                    html += '<div class="news__content-right">';
                    html += '<div class="module__inner-row title-row">';
                    html += '<div class="module__inner-col">';
                    html +=
                        '<div class="news__single-title font-h3 color-h3"><a class="news__link font-bold module__link" href="' +
                        data__value.permalink +
                        '" rel="nofollow" target="_blank">' +
                        data__value.post_title +
                        '</a></div>';
                    html += '</div>';
                    html += '</div>';
                    html += '<div class="module__inner-row excerpt-row">';
                    html += '<div class="module__inner-col">';
                    html += '<div class="news__excerpt">';
                    let excerpt_content = data__value.excerpt_content,
                        max_chars = 150;
                    if (excerpt_content.length > max_chars) {
                        let pos = excerpt_content.indexOf(' ', max_chars);
                        if (pos === -1) {
                            pos = max_chars;
                        }
                        excerpt_content = excerpt_content.substring(0, pos).trim() + '...';
                    }
                    html += excerpt_content;
                    html += '</div>';
                    html += '</div>';
                    html += '</div>';
                    html += '<div class="module__inner-row news__inner-row--cta">';
                    html += '<div class="module__inner-col news__inner-col--cta">';
                    html +=
                        '<div class="news__cta module__cta">' +
                        '<a class="news__more news__cta-btn module__cta-btn font-button color-button bg-color-button" href="' +
                        data__value.permalink +
                        '" rel="nofollow" target="_blank">Weiterlesen</a>';
                    html += '</div>';
                    html += '</div>';
                    html += '</div>';
                    html += '</div>';
                    let selector = '.dynamic-news--' + (parseInt(data__key) + 1);
                    if (this.el.querySelector(selector) !== null) {
                        document.querySelectorAll(selector).forEach((selector__value) => {
                            selector__value.innerHTML = html;
                        });
                    }
                });
            });
    }
}
